var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "subVideoScrollHider",
      style: _vm.allUsers.length > 8 ? "overflow-y: auto;" : "",
    },
    [
      _vm.subvideoOverflowContainer
        ? _c(
            "div",
            { staticClass: "leftScroll", on: { click: _vm.showLeft } },
            [_c("span", { staticClass: "iconfont icon-circle-left" })]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { ref: "subvideos", staticClass: "subvideos" }, [
        _c(
          "div",
          { ref: "subvideoInner", staticClass: "userVideos" },
          [
            _vm._l(_vm.allUsers, function (user) {
              return [
                _c("SmallView", {
                  key: user.userId,
                  attrs: {
                    user: user,
                    forceUseSrcView: _vm.isWhiteboardOpen,
                    controlId: _vm.controlId,
                  },
                  nativeOn: {
                    mouseenter: function ($event) {
                      return _vm.setcontrolId(user.userId)
                    },
                    mouseleave: function ($event) {
                      return _vm.setcontrolId("")
                    },
                  },
                }),
              ]
            }),
          ],
          2
        ),
      ]),
      _vm._v(" "),
      _vm.subvideoOverflowContainer
        ? _c(
            "div",
            { staticClass: "rightScroll", on: { click: _vm.showRight } },
            [_c("span", { staticClass: "iconfont icon-circle-right" })]
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/views/classroom1/components/SmallVideoList.vue?vue&type=template&id=3cf84b98&scoped=true&
// module id = null
// module chunks = 